<template>
    <div class="panel panel-default">
        <div class="panel-heading" role="tab" v-bind:id="'heading-' + table">
            <h4 class="panel-title">
                <a @click.prevent="toggle(table)">
                    {{table}}
                </a>
            </h4>
        </div>
        <div
        v-bind:id="'collapse-' + table"
        class="panel-collapse collapse"
        role="tabpanel">
            <div class="panel-body">
                <p>
                    <div class="form" v-show="showSearch">
                        <input type="text"
                        class="form-control input-sm"
                        v-model="filter"
                        placeholder="Search version">
                    </div>
                </p>

                <div v-if="useCart">
                    <div v-for="version in versions" :key="version.display">
                        <p>
                            <a href="#"
                               @click.prevent="addToBasket(version)">
                               <span class="glyphicon glyphicon-shopping-cart"></span>
                            </a>
                            {{version.display}}
                            <span v-if="version.fromNow">({{version.fromNow}})</span>
                        </p>
                    </div>
                </div>
                <div v-if="!useCart">
                    <div v-for="version in versions" :key="version.display">
                        <p>
                            <a href="#"
                               @click.prevent="viewNow(version)">
                               <span class="glyphicon glyphicon-circle-arrow-right"></span>
                               {{version.display}}
                               <span v-if="version.fromNow">({{version.fromNow}})</span>
                            </a>
                        </p>
                    </div>
                    <div style="text-align: center" v-if="showMore">
                        <a href="#" @click.prevent="more">
                            <span class="glyphicon glyphicon-menu-down"></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">

export default {
    props: ['table', 'useCart'],
    data() {
        return {
            loaded: false,
            filter: '',
            limit: 30,
        }
    },
    computed:{
        versions(){
            var versions = this.$store.state.basket.versions[this.table]
            var f = this.filter.toLowerCase()
            if (!this.filter) {
                if (versions && versions.length > 1){
                    return versions.slice(0, this.limit)
                } else {
                    return versions
                }
            } else {
                return _.filter(versions, (version)=>{
                    return (version.display.toLowerCase().indexOf(f) >= 0)
                }).slice(0, this.limit)
            }
        },
        showSearch() {
            var versions = this.$store.state.basket.versions[this.table]
            return (versions) && (versions.length > 1)
        },
        showMore() {
            var versions = this.$store.state.basket.versions[this.table]
            return (versions) && (versions.length > this.limit)
        }
    },
    methods: {
        toggle() {
            if (!this.loaded){
                this.loadVersions(this.table)
            } else {
                $('#collapse-' + this.table).collapse('toggle')
            }
        },
        loadVersions() {
            this.$store.dispatch("loadVersion", this.table).then(()=>{
                this.loaded = true
                $('#collapse-' + this.table).collapse('show')
            })
        },
        addToBasket(version) {
            this.$store.dispatch('addToCart', version)
        },
        viewNow(version) {
            this.$store.dispatch('clearCart')
            this.$store.dispatch('addToCart', version)
            this.$store.dispatch("executeBasket")
        },
        more() {
            this.limit += 30
        }
    }
}
</script>
<style type="text/css">
.panel-title {
    font-size: small;
    cursor: pointer;
}
.panel-body {
    font-size: small;
}
</style>
